import type { GameMode } from '../game/player-select';
import { GAME_HEIGHT, GAME_WIDTH, KoodooScene, TEXT_STYLES } from './base-scene';

interface MenuEntry {
  label: string;
  y: number;
  activate: (scene: MainMenu) => void;
}

export const MENU_ENTRIES: readonly MenuEntry[] = [
  {
    label: 'Highscore Race',
    y: 380,
    activate: (scene) => scene.startRaceMode('highscore_race'),
  },
  {
    label: 'Local Multiplayer',
    y: 438,
    activate: (scene) => scene.startRaceMode('local_multiplayer'),
  },
  {
    label: 'High Scores',
    y: 496,
    activate: (scene) => scene.scene.start('Highscores'),
  },
  { label: 'Settings', y: 554, activate: (scene) => scene.scene.start('Settings') },
  { label: 'Exit', y: 612, activate: (scene) => scene.exitGame() },
];

export class MainMenu extends KoodooScene {
  static readonly KEY = 'MainMenu';

  private air?: Phaser.GameObjects.Image;
  private airyObjects?: Phaser.GameObjects.Image;

  constructor() {
    super(MainMenu.KEY);
  }

  preload(): void {
    this.loadBackgrounds();
    this.load.image('main_logo', 'assets/images/main_logo.png');
  }

  create(): void {
    this.playMenuTheme();
    const { air, airyObjects } = this.addBackgrounds();
    this.air = air;
    this.airyObjects = airyObjects;

    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 4, 'main_logo');
    this.setCursor('generic');

    for (const entry of MENU_ENTRIES) {
      this.addMenuButton(entry);
    }
  }

  override update(): void {
    if (this.air) {
      this.air.rotation += 0.0005;
    }
    if (this.airyObjects) {
      this.airyObjects.rotation -= 0.0005;
    }
  }

  startRaceMode(mode: GameMode): void {
    this.session.startMode(mode);
    this.scene.start('PlayerSelect');
  }

  /**
   * `window.close()` only works on script-opened windows, so when the browser
   * refuses we fall back to the click-to-start gate instead of doing nothing.
   */
  exitGame(): void {
    this.session.audio.stopMusic();
    window.close();
    this.time.delayedCall(500, () => this.scene.start('Bootup'));
  }

  private addMenuButton(entry: MenuEntry): void {
    const button = this.add
      .text(GAME_WIDTH / 2, entry.y, entry.label, TEXT_STYLES.menu)
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: false });

    button.on('pointerover', () => {
      button.setAlpha(0.5);
      this.session.audio.playEffect('mouse_over');
    });
    button.on('pointerout', () => button.setAlpha(1));
    button.on('pointerup', () => {
      this.session.audio.playEffect('mouse_click');
      entry.activate(this);
    });
  }
}
